
import { ModalOptions } from '@/helpers/Modals'
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Accessible modal component
 */
@Component({ name: 'Modal' })
export default class extends Vue {
  @Prop({ required: true })
  modal: ModalOptions

  @Prop({ required: true })
  disabled: boolean

  open: boolean = false

  // If the modal has CSS transition, this will be set
  // to how long (in ms) the modal takes to finish the (CSS) transition.
  transitionDuration = 0

  mounted() {
    const modal = this.$refs.modal as HTMLDialogElement
    const modalWindow = this.$refs.modalWindow as HTMLDialogElement
    if (modal.showModal) {
      modal.showModal()
    } else {
      // .showModal is not supported in iOS < 15.4
      // fallback to using the 'open' attribute to open the modal
      this.open = true
    }

    modal.classList.add('open')

    const start = Date.now()
    // Prefer this over `window.computedStyle()` for the performance cost.
    modalWindow.addEventListener('transitionend', () => {
      this.transitionDuration = Date.now() - start
    })
  }

  close() {
    if (this.modal.closeable) {
      const modal = this.$refs.modal as HTMLDialogElement
      modal.classList.remove('open')

      setTimeout(() => {
        this.$emit('close')
      }, this.transitionDuration)
    }
  }

  get classes() {
    const mobileClass = `mobile-${this.modal.mobile}`
    const desktopClass = `desktop-${this.modal.desktop}`

    return ['modal', this.modal.size, this.modal.name, mobileClass, desktopClass, { disabled: this.disabled }]
  }

  handleBackdropClick(e) {
    if (!e.target.closest('.modal-window')) {
      this.close()
    }
  }
}
